import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "jwQuestionStuBank/";

// 教学质量评价 - 学生每门课程的问卷列表
export const teachEvaluateInfoPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "list", {
           data: _params,
           method: "GET",
         });
       };


// 教学质量评价 - 学生每门课程的问卷列表详情
export const teachEvaluateInfoView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};

// 教学质量评价 - 学生每门课程的问卷列表(网络课程)
export const teachEvaluateNetList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "netList", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/teachEvaluateInfo.js